import React from 'react';
import '../giveaway.css';
import { followRequired } from '../lib/giveaway-policy';

const buttonText = color => {
  const parts = (color || '#F59E0B').slice(1).match(/.{2}/g)?.map(value => parseInt(value, 16) / 255) || [1, 1, 1];
  const light = parts.map(value => value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4);
  return light[0] * 0.2126 + light[1] * 0.7152 + light[2] * 0.0722 > 0.179 ? '#101410' : '#ffffff';
};

export const GiveawayBrandFrame = ({ brand, children }) => (
  <div className="giveaway-page ph-no-capture ph-mask" style={{ '--giveaway-accent': brand?.accent || '#F59E0B', '--giveaway-background': brand?.background || '#131315', '--giveaway-button-text': buttonText(brand?.accent) }} data-testid="giveaway-page">
    <div className="giveaway-shell">
      <header className="giveaway-brand-header">
        {brand?.logo_url
          ? <img src={brand.logo_url} alt={brand.name} className="giveaway-logo" data-testid="giveaway-brand-logo" />
          : <strong className="giveaway-wordmark" data-testid="giveaway-brand-name">{brand?.name || 'Monthly giveaway'}</strong>}
        <span className="giveaway-eyebrow" data-testid="giveaway-month-label">Monthly giveaway</span>
      </header>
      {children}
      <footer className="giveaway-footer" data-testid="giveaway-disclaimer">
        No purchase necessary.{brand && !followRequired(brand) ? ' Following on Instagram is not required to enter or win.' : ''}
        <span>Powered by Advecti</span>
      </footer>
    </div>
  </div>
);